import React, { useCallback, useEffect, useRef, useState } from "react";
import Slider from 'react-slick';
import Lib from 'library'
import Global from 'library/Global'
// import styles from '../css/commonui.css';
// import $ from "jquery";
import Banner1 from '../images/img-banner01.png';
import Banner2 from '../images/img-banner02.png';
import Banner3 from '../images/img-banner03.png';
import Banner4 from '../images/img-banner04.png';
import Banner5 from '../images/img-banner05.png';
import Banner6 from '../images/img-banner06.png';
import { Link, useNavigate } from "react-router-dom";

const SlideBanner = () => {
    const slickRef = useRef(null);
    const navigate = useNavigate();
    // const previous = useCallback(() => slickRef.current.slickPrev(), []);
    // const next = useCallback(() => slickRef.current.slickNext(), []);
    // const pause = useCallback(() =>  slickRef.current.slickPause(), []);
    // const play = useCallback(() => slickRef.current.slickPlay(), []);
    // const [isPlay, setIsPlay] = useState(true);

    const settings = {
        dots: true,
        dotsClass: 'btn-box paging',
        customPaging: function (i) {
            return (
                <span>{i + 1}</span>
            );
        },
        appendDots: (dots) => (
            <div>
                <ul>
                    {dots}
                    <li className="total"><span><i>/</i>{dots.length}</span></li>
                </ul>
            </div>
        ),
        arrows: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    // 씽크풀 연동 
    const thinkPoolClick = () => {
        Lib.get(`/api/comm/terms/agree/chk/ctgry/STOCK`,
            data => {
                if (data.termsCtgryAgreeYn === "Y") {
                    navigate("/thinkpool/thinkInfo")
                } else {
                    navigate("/thinkpool/thinkIntro")
                }
            }
        )
    }

    useEffect(() => {
        // TODO GET IMAGES
    }, []);

    return (
        <div className="cmm-banner-box">
            <Slider {...settings} ref={slickRef}>
                {/* {
                    Lib.isNotNull(images) && images.map((path) => {
                        return (
                            <a href="">
                                <span className="img"><img src={path}/></span>
                            </a>
                        )
                    })
                } */}
                {/* <a href="">
                    <span className="img"><img src={Banner1}/></span>
                </a>
                <a href="">
                    <span className="img"><img src={Banner2}/></span>
                </a> */}
                <Link to="/edocCertificate">
                    <span className="img"><img src={Banner5} alt="필요한 증명서, 모에서 바로 발급!" /></span>
                </Link>
                {/* <Link to="/recommend/mcScore">
                    <span className="img"><img src={Banner4} alt="자동차번호만으로 대안신용정수 확인이 가능??"/></span>
                </Link> */}
                <Link to="/recommend/grant">
                    <span className="img"><img src={Banner3} alt="내가 놓친 정부 혜택 숨은 정부지원금이 5,000,000원??" /></span>
                </Link>
                <Link to="/recommend/financeSaving">
                    <span className="img"><img src={Banner2} alt="높은 금리 상품 조회 모이면 금리가 올라가는 예금" /></span>
                </Link>
                <div onClick={thinkPoolClick}>
                    <span className="img"><img src={Banner1} alt="주식투자 어렵다면 My Stock Manager가 다- 알려줌" /></span>
                </div>
                {Global.test &&
                    <div onClick={() => navigate("/recommend/realEstate")}>
                        <span className="img"><img src={Banner6} alt="등기부등본 완전정복! 전세사기, 꼭 피하고 싶어!" /></span>
                    </div>}
            </Slider>
            {/* <div className="btn-box"> */}

            {/* <button type="button" className="prev" onClick={previous}><span>이전</span></button> */}
            {/* <div className="dot"></div> */}
            {/* {!isPlay && <button type="button" className="play" onClick={() => {play(); setIsPlay(true)}}><span>자동재생 시작</span></button>} */}
            {/* {isPlay && <button type="button" className="stop" onClick={() => {pause(); setIsPlay(false)}}><span>자동재생 멈춤</span></button>} */}
            {/* <button type="button" className="next" onClick={next}><span>다음</span></button> */}
            {/* </div> */}
        </div>
    )
}


export default SlideBanner;